import Event, { IEvent } from '@/models/Event'
import User, { IUser } from '@/models/User'
import ModelBase, {IModelBase} from '@/models/ModelBase'
import { KeyPair } from '@/types/KeyPair'
import MessageUser, {IMessageUser} from '@/models/MessageUser'

export interface IMessage extends IModelBase {
  title?: string
  content?: string
  event?: IEvent
  progress_status?: string
  progress_status_text?: string
  private: boolean
  test: boolean
  active: boolean
  message_users?: Array<IMessageUser>
  to?: IUser
}

export default class Message extends ModelBase {
  title? = ''
  content? = ''
  event = new Event()
  progress_status?: string
  progress_status_text?: string
  private = false
  test = false
  active?: boolean = true
  message_users?: Array<MessageUser> = []
  users?: Array<User> = []
  to?: User

  constructor(defaults?: IMessage) {
    super(defaults)
    if (defaults) {
      this.title = defaults.title
      this.content = defaults.content
      this.event = new Event(defaults.event)
      this.progress_status = defaults.progress_status
      this.progress_status_text = defaults.progress_status_text
      this.private = defaults.private
      this.test = defaults.test
      this.active = defaults.active
      this.message_users = defaults.message_users?.map(u => new MessageUser(u)) || []
      this.to = defaults.to ? new User(defaults.to) : undefined
    }
  }

  get sentToString(): string {
    const to = []
    if (this.private) {
      return this.to ? `${this.to.name} <${this.to.email}>` : '個人'
    } else if (this.test) {
      to.push('テストメール')
    } else if (this.progress_status) {
      to.push('全ユーザー')
      to.push(this.progress_status_text)
    } else if (this.event) {
      to.push(this.event.title)
    }
    switch (this.active) {
      case true:
        to.push('本登録済')
        break
      case false:
        to.push('仮登録')
        break
    }
    return to.join(' / ')
  }

  toParams(): KeyPair {
    return {
      title: this.title,
      content: this.content,
      event_id: this.event?.id,
      progress_status: this.progress_status,
      private: this.private,
      test: this.test,
      active: this.active,
      user_ids: this.users.map(u => u.id),
    }
  }
}
